import React, { useEffect, useState } from "react";
import { publicApi } from "../lib/api";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Lock } from "lucide-react";
import { useMemberAuth } from "../context/MemberAuthContext";

const Masterclasses = () => {
  const { member } = useMemberAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    publicApi.get("/webinars")
      .then(({ data }) => setList(Array.isArray(data) ? data : []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="section-eyebrow text-[#0d2a20]/60 mb-6">Masterclasses</div>
        <h1 className="hero-title text-[52px] md:text-[96px] leading-[0.95] max-w-[1200px]">Learn from the people <span className="font-serif-i text-[#e0684d]">building it.</span></h1>
        <p className="mt-8 max-w-[820px] text-[17px] leading-relaxed text-[#0d2a20]/80">Members-only masterclasses with founders, investors and leaders working on Africa&rsquo;s next chapter. Click a masterclass to see the full details and reserve your seat.</p>
        {!member && (
          <div className="mt-6 inline-flex items-center gap-2 px-3 py-2 rounded-md text-[13px]" style={{ background: '#fde5c7', color: '#8a4a10' }} data-testid="masterclasses-member-gate">
            <Lock size={14} /> Masterclass seats are members-only — <Link to="/login?next=/webinars" className="underline">Sign in</Link> or <Link to="/join" className="underline">apply to join</Link> the Diaspora Network to reserve.
          </div>
        )}
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
        {loading ? (
          <div className="rounded-lg p-10 text-center text-[14px] text-[#0d2a20]/60" style={{ background: '#fbf8ef' }}>Loading…</div>
        ) : error ? (
          <div className="rounded-lg p-10 text-center text-[14px] text-[#0d2a20]/60" style={{ background: '#fbf8ef' }}>We couldn&rsquo;t load the masterclasses right now. Please try again shortly.</div>
        ) : list.length === 0 ? (
          <div className="rounded-lg p-10 text-center text-[14px] text-[#0d2a20]/60" style={{ background: '#fbf8ef' }} data-testid="masterclasses-empty">No masterclasses scheduled yet — check back soon.</div>
        ) : (
          <div className="grid md:grid-cols-3 gap-6">
            {list.map(w => (
              <div key={w.id} className="rounded-lg p-6 org-card flex flex-col" style={{ background: '#fbf8ef' }} data-testid={`masterclass-card-${w.id}`}>
                <div className="flex items-center gap-2 text-[12px] text-[#0d2a20]/60 mb-6">
                  <span className="px-2 py-1 rounded flex items-center gap-1" style={{ background: '#ece5d3' }}><Calendar size={12} /> {w.date}</span>
                  {w.tag && <span>{w.tag}</span>}
                </div>
                <h3 className="text-[22px] font-medium mb-2 leading-tight">{w.title}</h3>
                {(w.speaker_name || w.speaker) && <p className="text-[13px] text-[#0d2a20]/70 mb-6">{w.speaker_name || w.speaker}</p>}
                <div className="mt-auto flex items-center justify-between">
                  <div className="text-[12px] text-[#0d2a20]/60">{w.is_full ? (w.waitlist_enabled ? 'Waiting list open' : 'Masterclass full') : 'Seats available'}</div>
                  <Link to={`/webinars/${w.id}`} className="inline-flex items-center gap-2 px-4 py-2 rounded-md btn-green text-[13px]">Learn more <ArrowUpRight size={14} /></Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Masterclasses;
